import React, { useState } from "react";
import "../Styles/customer.css";
import { ImCancelCircle } from "react-icons/im";
import { useNavigate } from "react-router-dom";
import BanksTable from "../components/Modals/BanksTable";
import CustomerBank from "../components/Modals/CustomerBank";
import QuantityTable from "./Modals/QuantityTable";

interface OptionProps {
  setOption: React.Dispatch<React.SetStateAction<boolean>>;
  user: any;
  selectedCustomer: any;
  setOpenBank: React.Dispatch<React.SetStateAction<boolean>>;
  setBanks: React.Dispatch<React.SetStateAction<any>>;
  banks: any;
  openBank: boolean;
}

const Option: React.FC<OptionProps> = ({
  setOption,
  user,
  selectedCustomer,
  setOpenBank,
  setBanks,
  banks,
  openBank,
}) => {
  const navigate = useNavigate();
  const [openQuan, setOpenQuan] = useState(false);
  const [quan, setQuan] = useState<any>({});
  const [cBank, setCBank] = useState(false);
  const [getUserId, setUserId] = useState<string>("");

  const handleModal = (id: string) => {
    setCBank(!cBank);
    setUserId(id);
  };

  return (
    <div className="opt">
      <ImCancelCircle
        className="catCancel"
        style={{
          alignSelf: "flex-end",
          marginTop: ".2em",
          display: "flex",
          marginLeft: "auto",
          marginRight: "1em",
          cursor: "pointer",
        }}
        onClick={() => setOption(false)}
      />

      <ul>
        <li onClick={() => handleModal(selectedCustomer?._id)}>Choose bank</li>
        <li
          onClick={() => {
            setBanks(selectedCustomer);
            setOpenBank(true);
          }}
        >
          View Balance in Bank accounts
        </li>
        <li
          onClick={() => {
            setQuan(selectedCustomer);
            setOpenQuan(true);
          }}
        >
          View Quantity
        </li>
        <li
          onClick={() => {
            console.log("uui", user);
            navigate("/dashboard/transaction", { state: selectedCustomer });
          }}
        >
          View Transaction
        </li>
        <li
          onClick={() => {
            navigate("/dashboard/refund", { state: selectedCustomer });
          }}
        >
          Refund
        </li>
      </ul>
      {openQuan ? <QuantityTable quan={quan} setOpenQuan={setOpenQuan} /> : null}
      {openBank ? <BanksTable banks={banks} setOpenBank={setOpenBank} /> : null}
      {cBank ? (
        <CustomerBank
          cusID={selectedCustomer?._id}
          getUserId={getUserId}
          setCBank={setCBank}
        />
      ) : null}
    </div>
  );
};

export default Option;
